import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { format, toZonedTime } from 'date-fns-tz'
import { Plus } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import Loader from '../../Loader/Loader'
import { VisitCreateModal } from '../VisitCreateModal/VisitCreateModal'
import { shouldDisplayPoolInfo } from '../helpers'

import { VisitDetailsModal } from './VisitDetailsModal'

export const VisitsSection = ({
  addGuestPass,
  amenityClientId,
  clientId,
  fetchGuestPassVisits,
  guestPassVisits = [],
  isLoading,
  showMoreButton,
  timezone,
  clientBuildingId,
}) => {
  const { t } = useTranslation(['clients-legacy'])
  const [guestPassVisit, setGuestPassVisit] = useState(null)
  const [openAddGuestPassVisit, setOpenAddGuestPassVisit] = useState(false)

  const isPoolInfoAvailable = shouldDisplayPoolInfo(clientBuildingId)

  useEffect(() => {
    if (guestPassVisit) {
      const updatedVisit = guestPassVisits.find((visit) => visit.id === guestPassVisit.id)
      if (updatedVisit) {
        setGuestPassVisit(updatedVisit)
      }
    }
  }, [guestPassVisits])

  if (guestPassVisits.length === 0) {
    return (
      <div className="visits">
        <div className="title">{t('clients-legacy:profileView.visits.checkInsTitle')}</div>
        {isLoading ? (
          <div className="loader-wrapper">
            <Loader />
          </div>
        ) : (
          <React.Fragment>
            <div className="visit-row">
              <button
                className="button button-primary add-visit-button auto-width"
                onClick={() => setOpenAddGuestPassVisit(true)}
              >
                <Plus /> {t('clients-legacy:profileView.visits.addCheckin')}
              </button>
            </div>
            {openAddGuestPassVisit && (
              <VisitCreateModal
                amenityClientId={amenityClientId}
                clientId={clientId}
                addGuestPass={addGuestPass}
                onClose={() => setOpenAddGuestPassVisit(false)}
              />
            )}
          </React.Fragment>
        )}
      </div>
    )
  }

  const onGuestPassVisitClick = (visit) => {
    setGuestPassVisit(visit)
  }

  const onGuestPassVisitClose = () => {
    setGuestPassVisit(null)
  }

  return (
    <div className="visits">
      <div className="title">{t('clients-legacy:profileView.visits.checkInsTitle')}</div>
      {guestPassVisits.map((visit, index) => (
        <div className="visit-row" key={`${visit.id}-${index}`}>
          <div className="visit-title">
            {format(toZonedTime(visit.createdAt, timezone), 'MM/dd/yyyy hh:mm a')}
          </div>
          <div className="visit-passes-count">
            {t('clients-legacy:profileView.visits.passesUsed', { count: visit.guestCount })}
          </div>
          {isPoolInfoAvailable && <div>{visit.placeId?.name}</div>}
          <div className="value-link" onClick={() => onGuestPassVisitClick(visit)}>
            {t('clients-legacy:profileView.visits.viewDetails')}
          </div>
        </div>
      ))}
      {guestPassVisit && (
        <VisitDetailsModal
          onClose={onGuestPassVisitClose}
          fetchGuestPassVisits={fetchGuestPassVisits}
          guestPassVisit={guestPassVisit}
          timezone={timezone}
        />
      )}
      {openAddGuestPassVisit && (
        <VisitCreateModal
          amenityClientId={amenityClientId}
          clientId={clientId}
          addGuestPass={addGuestPass}
          onClose={() => setOpenAddGuestPassVisit(false)}
        />
      )}
      {showMoreButton && (
        <button onClick={() => fetchGuestPassVisits()} className="show-more-button">
          {t('clients-legacy:profileView.visits.showMore')}
        </button>
      )}
      <div className="add-visit-button-container">
        <button
          className="button button-primary auto-width"
          onClick={() => setOpenAddGuestPassVisit(true)}
        >
          <Plus /> {t('clients-legacy:profileView.visits.addCheckin')}
        </button>
      </div>
    </div>
  )
}

VisitsSection.propTypes = {
  addGuestPass: PropTypes.func,
  amenityClientId: PropTypes.string,
  clientId: PropTypes.number,
  guestPassVisits: PropTypes.arrayOf(
    PropTypes.shape({
      householdMembers: PropTypes.array,
      createdAt: PropTypes.number,
      guestCount: PropTypes.number,
      clientId: PropTypes.object,
      id: PropTypes.number,
    }),
  ),
  fetchGuestPassVisits: PropTypes.func,
  isLoading: PropTypes.bool,
  showMoreButton: PropTypes.bool,
  timezone: PropTypes.string,
  clientBuildingId: PropTypes.string,
}
